export default __webpack_public_path__ + "static/media/humanely.327b291d.png";